"use strict";Object.defineProperty(exports, "__esModule", { value: true });exports.default = void 0; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default =
{
  data: function data() {
    return {
      tableData: [], // 列表数据
      searchData: {
        mobile: '',
        email: '',
        type: '',
        status: '',
        time: '',
        page: 1, // 当前页码
        rows: 10 // 页码条数
      },
      newadd: false,
      title: '查看',
      addData: {
        images: [],
        image1: '',
        image2: '',
        image3: '',
        image4: '' },

      pageData: {
        page: 1,
        rows: 10,
        total: 0,
        pages: 1 },

      addpageData: {
        page: 1,
        rows: 10,
        total: 0,
        pages: 1 },


      pickerOptions: {
        disabledDate: function disabledDate(time) {
          return time.getTime() > Date.now();
        } } };



  },
  filters: {
    statusFilter: function statusFilter(val) {
      if (val === 1) {
        return '待处理';
      } else if (val === 2) {
        return '已处理';
      }
    },
    typeFilter: function typeFilter(val) {
      if (val === 1) {
        return '问题';
      } else if (val === 2) {
        return '建议';
      }
    } },

  mounted: function mounted() {
    var self = this;
    self.init();
  },
  methods: {
    init: function init() {
      var self = this;
      var params = Object.assign({}, self.searchData);
      if (params.time) {
        params.createTimeStart = params.time[0] + ' 00:00:00';
        params.timeEnd = params.time[1] + ' 23:59:59';
      }
      delete params['time'];
      self.getData('/api/feedback', params, function (res) {
        self.tableData = res.list;
        self.pageData.page = res.pageNum;
        self.pageData.total = res.total;
      });
    },

    resetFun: function resetFun() {// 重置
      this.searchData.mobile = '';
      this.searchData.email = '';
      this.searchData.type = '';
      this.searchData.status = '';
      this.searchData.time = '';
      this.init();
    },

    searchFun: function searchFun() {// 搜索事件
      this.searchData.page = 1;
      this.init();
    },
    handleSizeChange: function handleSizeChange(val) {// 分页条数
      this.searchData.rows = val;
      this.searchData.page = 1;
      this.init();
    },
    handleCurrentChange: function handleCurrentChange(val) {// 分页页码
      this.searchData.page = val;
      this.init();
    },
    changeStatusFun: function changeStatusFun(val) {
      var self = this;
      self.searchData.status = '';
      if (val === '1') {
        self.searchData.status = '1';
      } else if (val === '2') {
        self.searchData.status = '2';
      }
    },
    delMenu: function delMenu(delId) {
      var self = this;
      self.$confirm('确定删除该记录吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
        center: true }).
      then(function () {
        self.delData('/api/feedback/' + delId, {}, function (res) {
          self.$message({
            message: '删除成功!',
            type: 'success' });

          self.searchData.page = 1;
          self.init();
        });
      }).catch(function () {});
    },
    enableFun: function enableFun(item, type) {
      var self = this;
      console.log(item);
      if (item.status === 2) {
        this.$message({
          message: '该问题已处理，无需修改!',
          type: 'warning' });

        return;
      }
      self.putData('/api/feedback/' + item.id, {}, function (res) {
        self.$message({
          message: '处理成功!',
          type: 'success' });

        item.enable = type;
        self.init();
      });
    },
    lookFun: function lookFun(item) {// 查看弹窗
      var self = this;
      self.title = '查看';
      self.addData.image1 = item.image1;
      self.addData.image2 = item.image2;
      self.addData.image3 = item.image3;
      self.addData.image4 = item.image4;

      self.addData.images = [];
      if (item.image1) {
        self.addData.images.push(item.image1);
      }
      if (item.image2) {
        self.addData.images.push(item.image2);
      }
      if (item.image3) {
        self.addData.images.push(item.image3);
      }
      if (item.image4) {
        self.addData.images.push(item.image4);
      }

      if (self.addData.images.length > 0) {
        self.newadd = true;
      } else {
        self.$message({
          message: '无图片，无需查看!',
          type: 'warning' });

        self.newadd = false;
      }
    },
    closeRefund: function closeRefund(done) {// 重置新增列表
      this.$refs['addForm'].resetFields();
      done();
    },
    onCencal: function onCencal() {
      this.newadd = false;
      this.$refs['addForm'].resetFields();
    } } };exports.default = _default;